import { useEffect } from 'react'
import _ from 'underscore'

import Api from 'services/api'

import { useStoreContext } from 'hooks/StoreContext'

const useDefaultFirmwareLoads = () => {
  const { defaultFirmwareLoads, setDefaultFirmwareLoads, areDefaultFirmwareLoadsLoaded, setAreDefaultFirmwareLoadsLoaded } = useStoreContext()

  useEffect(() => {
    setDefaultFirmwareLoads(null)
    setAreDefaultFirmwareLoadsLoaded(false)

    Api.DefaultFirmwareLoads.get()
      .then((res) => {
        setAreDefaultFirmwareLoadsLoaded(true)
        if (!_.isEmpty(res.defaultFirmwareLoads)) {
          setDefaultFirmwareLoads(res.defaultFirmwareLoads)
        }
      })
      .catch(() => {
        setAreDefaultFirmwareLoadsLoaded(true)
        setDefaultFirmwareLoads(null)
      })
  }, [setDefaultFirmwareLoads, setAreDefaultFirmwareLoadsLoaded])

  return { defaultFirmwareLoads, areDefaultFirmwareLoadsLoaded }
}

export default useDefaultFirmwareLoads
